module.exports = __webpack_public_path__ + "static/andfarr-cd15473bba0f48b41d8c3943055e5e80.jpg";